
/* Instructions
---------------
1. Put an attribute on any element that might have text too long to fit.
2. In that attribute, create an array of rules, in the format below. Create as little or many rules 
   as necessary to make this element perform with more text. 
3. Think of the width key-value pair as a mobile-first media query, such as: @media (min-width: ?)
4. The maxHeight key-value pair defines how tall the element is allowed to grow to before 
   shrinking/collapsing take place.
5. The minFontSize key-value pair defines how small the font can be set to, before the element is 
   clamped with an ellipsis.
6. For elements with FitText logic that are hidden on load (user has to interact with component to 
   display a slide, etc), then trigger the custom event called 'ESRIFitTextShown'. Example:
   utils.triggerEvent(document,'ESRIFitTextShown');


/* Sample Element
-----------------
<p class="sample_element" 
  data-fit-text="[{'minWidth':0, 'maxHeight':80, 'minFontSize':26}, {'minWidth':860, 'maxHeight':80, 'minFontSize':30}"
  data-fit-text-content="Lorem ipsum.">Lorem ipsum.</p>


/* Sample Rules
---------------
[
  { minWidth:0, maxHeight:80, minFontSize:26 }, 
  { minWidth:480, maxHeight:120, minFontSize:30 }
]

*/

document.addEventListener('DOMContentLoaded', () => {
  class FitText {
    constructor() {
      const elements = esriClientUtils.selectAll('[data-fit-text]');

      if (elements && elements.length) {
        this.createFitMe(elements);
      }
    }

    cleanClamp ({fitMe}) {
      fitMe.el.innerText = fitMe.content;
    }

    cleanShrink ({fitMe}) {
      fitMe.el.style.height = 'auto';
      fitMe.el.style.removeProperty('font-size');
    }

    fitText ({fitMe}) {
      if (fitMe.el.offsetHeight > 0) { // if visible
        // First try to shrink, then 'clamp' with elllipsis if necessary.
        const shrinkSuccess = this.applyShrink({fitMe});
        if (!shrinkSuccess) {
          this.applyClamp({fitMe});
        }
      }
    }

    applyShrink ({fitMe}) {
      this.cleanClamp({fitMe});
      this.cleanShrink({fitMe});

      const wW = window.innerWidth;
      let fontSize = parseInt(window.getComputedStyle(fitMe.el).fontSize);
      let maxHeight = 0;
      let minFontSize = 0;
      let shrinkSuccess = true;

      for (const rule of fitMe.rules) {
        if (wW > rule.minWidth) {
          this.cleanShrink({fitMe});
          maxHeight = rule.maxHeight;
          minFontSize = rule.minFontSize;
        }
      }

      while (shrinkSuccess && fitMe.el.scrollHeight > maxHeight) {
        if (fontSize > minFontSize) {
          fontSize -= 1;
          fitMe.el.style.fontSize = `${fontSize}px`;
        } else {
          shrinkSuccess = false;
        }
      }
      
      return shrinkSuccess;
    }
  
    applyClamp ({fitMe}) {
      this.cleanClamp({fitMe});

      const wW = window.innerWidth;
      let maxHeight = 0;

      for (const rule of fitMe.rules) {
        if (wW > rule.minWidth) {
          maxHeight = rule.maxHeight;
        }
      }

      const numLines = this.getNumLines(maxHeight, {fitMe});

      window.clamp(fitMe.el, numLines);
      fitMe.el.classList.add('ellipsis-clamped');
    }

    getRules (el) {
      let rules = el.getAttribute('data-fit-text').replace(/'/g, '\"');
      return JSON.parse(rules);
    }

    getNumLines (maxHeight, {fitMe}) {
      const lineHeight = parseInt(window.getComputedStyle(fitMe.el).lineHeight);
      const padTop = parseInt(window.getComputedStyle(fitMe.el).paddingTop);
      const padBottom = parseInt(window.getComputedStyle(fitMe.el).paddingBottom);
      const numLines = parseInt((maxHeight - padTop - padBottom) / lineHeight);

      return numLines ? numLines : 1;
    }

    createFitMe (elements) {
      elements.forEach((element) => {
        const fitMe = {
          el: element,
          rules: this.getRules(element),
          content: element.innerText
        };

        this.fitText({fitMe});

        const updateLayout = esriClientUtils.debounce((e) => {
          this.fitText({fitMe});
        }, 500);

        window.addEventListener('resize', updateLayout, false);

        fitMe.el.addEventListener('ESRIFitTextShown', () => {
          this.fitText({fitMe});
        });
      });      
    }
  }

  new FitText();
});
